export default "__VITE_ASSET__xgKnhx$k__"